module.exports = __webpack_public_path__ + "static/desktop/img/param-mobile-album.59cafffb.png";